import { z } from "zod";
import { apiBigIntIdSchema, apiIntIdSchema } from "./ids.js";
/**
 * Inbox SSE invalidation events. Payloads are hints only; clients must refetch
 * authoritative REST endpoints. Do not put Message/Conversation DTOs, tokens,
 * or provider payloads here.
 */
export const CONVERSATION_CHANGED_EVENT_TYPE = "CONVERSATION_CHANGED";
export const conversationChangedEventSchema = z.object({
    type: z.literal(CONVERSATION_CHANGED_EVENT_TYPE),
    organizationId: apiIntIdSchema,
    conversationId: apiIntIdSchema,
    occurredAt: z.string().datetime(),
});
/**
 * Social Comments V1 invalidation hint. Clients refetch authoritative REST
 * endpoints; no comment text or provider payload is carried here.
 */
export const SOCIAL_COMMENT_CHANGED_EVENT_TYPE = "SOCIAL_COMMENT_CHANGED";
export const socialCommentChangedEventSchema = z.object({
    type: z.literal(SOCIAL_COMMENT_CHANGED_EVENT_TYPE),
    organizationId: apiIntIdSchema,
    socialCommentId: apiBigIntIdSchema,
    socialPostId: apiBigIntIdSchema,
    occurredAt: z.string().datetime(),
});
//# sourceMappingURL=realtime-events.js.map